<template>
  <card-placeholder-banner
    class="tw-w-full"
    type="SAT"
    :data-test-id="`msp-dashboard-chart-banner`"
  >
    <template #title>{{ t("sat-completed-lures-clicked") }}</template>
    <template #text>
      {{ t("demo-data-sat") }}
    </template>
  </card-placeholder-banner>
</template>
<script setup lang="ts">
import CardPlaceholderBanner from "@/modules/Dashboard/components/CardPlaceholderBanner/CardPlaceholderBanner.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>
